import React from 'react';

/* ── Figma Content-card palette (node 1741:55617) ────────────────────────── */
export const CSENT = {
  positive: { donut: '#059669', dot: '#047857' },
  neutral: { donut: '#E9D9FD', dot: '#A78BFA' },
  negative: { donut: '#EAB308', dot: '#CA8A04' },
  toxic: { donut: '#DC2626', dot: '#DC2626' },
};

// Score → tone. Higher score = safer. Matches Figma legend (Safe / Caution / Risk)
// and the redesign row colours: dot/bar use the saturated hue, the score number a
// slightly deeper shade.
export function categoryTone(score: number) {
  if (score >= 90) return { dot: '#059669', bar: '#059669', text: '#047857' }; // safe
  if (score >= 70) return { dot: '#D97706', bar: '#D97706', text: '#D97706' }; // caution
  return { dot: '#DC2626', bar: '#DC2626', text: '#DC2626' };                  // risk
}

export function RiskLegendItem({ color, label }: { color: string; label: string }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
      <span style={{ width: 8, height: 8, borderRadius: '50%', background: color }} />
      <span style={{ fontSize: 12, fontWeight: 500, color: '#737373' }}>{label}</span>
    </span>
  );
}
